import sortBy from "lodash.sortby";
import { match } from "ts-pattern";

export const EMPTY_PROBLEM_TITLE = "対象の課題に分類されたデータはありません";

export type Fluctuation = "increased" | "decreased" | "unchanged";

export class Problem {
  constructor(
    public readonly title: string,
    public readonly detail: string,
    public readonly caseCount: number,
    public readonly suggestion: string,
    public readonly fluctuation: Fluctuation = "unchanged",
  ) {}

  static createEmptyProblem(title: string): Problem {
    return new Problem(title, "", 0, "");
  }

  percentage(totalCaseCount: number): number {
    return totalCaseCount > 0 ? (this.caseCount / totalCaseCount) * 100 : 0;
  }

  get isEmptyProblem(): boolean {
    return this.caseCount === 0;
  }

  updateFluctuation(fluctuation: Fluctuation): Problem {
    return new Problem(
      this.title,
      this.detail,
      this.caseCount,
      this.suggestion,
      fluctuation,
    );
  }
}

export const OTHER_INQUIRY_TITLE = "その他問い合わせ";
export const OTHER_PROBLEM_TITLE = "その他の課題";

export class Summary {
  constructor(
    public readonly overview: string,
    public readonly totalCaseCount: number,
    public readonly problems: Problem[] = [],
  ) {
    this.problems = sortBy(
      problems,
      (problem) =>
        match(problem.title)
          .with(OTHER_INQUIRY_TITLE, () => 2)
          .with(OTHER_PROBLEM_TITLE, () => 1)
          .otherwise(() => -problem.caseCount),
    );
  }
}
